import unitJobs from "@frog/source/data/unit-jobs.js"
import games from "@frog/source/data/games/index.js"
import unitsprites from "@frog/source/data/unitsprites.js"
import audiotriggers from "@frog/source/data/audiotriggers.js"
import Preload from "@frog/source/utility/Preload.js"

const preload = {"images": {}}

Object.values(unitsprites).map((unitspritesSection) => {
    Object.values(unitspritesSection).forEach((imageURL) => {
        preload.images[imageURL] = {"url": imageURL}
    })
})

Object.values(unitJobs).forEach((unit) => {
    if(unit.portraits != undefined) {
        Object.values(unit.portraits).forEach((portrait) => {
            const imageURL = portrait
            preload.images[imageURL] = {"url": imageURL}
        })
    }
    if(unit.sprites != undefined) {
        Object.values(unit.sprites).forEach((sprite) => {
            if(sprite.frames instanceof Array) {
                sprite.frames.forEach((frame) => {
                    const imageURL = frame.image
                    preload.images[imageURL] = {
                        "url": imageURL,
                    }
                })
            }
        })
    }
})

Object.values(games).forEach((game) => {
    Object.values(game.chapters).forEach((chapter) => {
        let imageURLs = chapter.stage.images || [chapter.stage.image]
        imageURLs.forEach((imageURL) => {
            if(imageURL == undefined) return
            preload.images[imageURL] = {"url": imageURL}
        })
    })
    Object.values(game.player.party.units).forEach((unit) => {
        if(unit.portraits != undefined) {
            Object.values(unit.portraits).forEach((portrait) => {
                const imageURL = portrait
                if(imageURL == undefined) return
                preload.images[imageURL] = {"url": imageURL}
            })
        }
        if(unit.sprites != undefined) {
            Object.values(unit.sprites).forEach((sprite) => {
                if(sprite.frames instanceof Array) {
                    sprite.frames.forEach((frame) => {
                        const imageURL = frame.image
                        preload.images[imageURL] = {"url": imageURL}
                    })
                }
            })
        }
    })
})

export default new Preload(preload)
